import { Button } from "antd"
import { EditOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import { useAuth } from "../../../contexts/auth"

EditButton.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object
}

export function EditButton ({
  onClick,
  style,
  ...props
}) {

  return (
    <Button
      onClick={onClick}
      style={{ float: "right", ...style }}
      shape="circle"
      icon={<EditOutlined />}
      {...props} />
  )
}
